import { type IWidgetConfigComponentProps } from '@framework/engine/schema/directives/IWidgetDirectiveType.ts';
import { WidgetConfigurationSlotRender } from '@framework/engine/schema/widgets/repository/common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '@framework/engine/schema/widgets/repository/common/config-slots/WidgetConfigurationSlots.tsx';
import { SwitchInput } from '@framework/form/inputs/SwitchInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { SWITCH_EVIDENCE_CARD_LAYOUT } from '@framework/form/item/formItemLayouts.ts';
import { SwitchEvidenceCard } from '@framework/ui/components/configuration-card/SwitchEvidenceCard.tsx';
import { WidgetConfigurationSubCard } from '@framework/ui/components/configuration-card/widget/WidgetConfigurationSubCard.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { IconPencilCog } from '@tabler/icons-react';
import { Flex, Tooltip } from 'antd';
import { useWatch } from 'react-hook-form';

export interface IIntegrableDirectiveConfigComponentProps
  extends IWidgetConfigComponentProps {}

/**
 * Sub-card "Integrazione": configura la modificabilità del campo in fase di
 * integrazione.
 */
export function IntegrableDirectiveConfigComponent(
  props: IIntegrableDirectiveConfigComponentProps,
) {
  const isDisabled = useWatch({ name: `${props.name}.disabled` });

  if (!process.env.BUILD_FLAGS_ADMIN_FRONTOFFICE) return null;

  return (
    <WidgetConfigurationSlotRender
      slot={WidgetConfigurationSlots.Semantic}
      order={50}
    >
      <WidgetConfigurationSubCard
        icon={<TbIcon icon={IconPencilCog} />}
        title="Integrazione"
        anchorTitle="integrazione"
        description="Permette di configurare la modificabilità del dato in fase di integrazione."
        summary={
          <Tooltip
            title={
              isDisabled
                ? 'Il campo non sarà modificabile in fase di integrazione.'
                : 'Il campo è modificabile in fase di integrazione.'
            }
          >
            <StyledTag color={isDisabled ? 'red' : 'green'} tabIndex={0}>
              {isDisabled ? 'Non modificabile' : 'Modificabile'} in integrazione
            </StyledTag>
          </Tooltip>
        }
      >
        <FormItem
          name={`${props.name}.disabled`}
          label="Disabilitazione Integrazione"
          layout={SWITCH_EVIDENCE_CARD_LAYOUT}
        >
          <SwitchEvidenceCard>
            <SwitchInput name={`${props.name}.disabled`} align="start">
              <Flex vertical>
                <b>Disabilita la modifica in fase di integrazione</b>
                <span>
                  Se selezionato, l&apos;utente non potrà modificare il campo in
                  fase di integrazione.
                </span>
              </Flex>
            </SwitchInput>
          </SwitchEvidenceCard>
        </FormItem>
      </WidgetConfigurationSubCard>
    </WidgetConfigurationSlotRender>
  );
}
